import React, { useEffect, useState } from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { WcbQueueKeyType } from '../types/WcbQueueKeyType';

type WcbQueueKeySelectProps = {
    iimclient: ConfigClientType;
    changeSelectedQueue: Function;
};

const WcbQueueKeySelect = ({ iimclient, changeSelectedQueue }: WcbQueueKeySelectProps) => {
    const queues: Array<WcbQueueKeyType> = iimclient.callbackQueues;
    const [queuesOpen, setQueuesOpen] = useState([...queues.map(() => false)]);

    const isQueueOpen = (queue: WcbQueueKeyType) => {
        return (
            (queue.timeId &&
                (window as any).PuzzelClient.timeExit(iimclient.customerKey, queue.timeId).then(
                    function (t) {
                        if (t && t.Ok && t.Exit && !/open/i.test(t.Exit)) {
                            return Promise.resolve(false);
                        } else return Promise.resolve(true);
                    }
                )) ||
            Promise.resolve(true)
        );
    };

    useEffect(() => {
        Promise.all(queues.map((queue) => isQueueOpen(queue))).then((values) => {
            setQueuesOpen([...values]);
        });
    }, []);

    return (
        <>
            <select
                className="if dropdown-select"
                name="selectedQueueKey"
                id="selectedQueueKey"
                defaultValue=""
                aria-labelledby="wcb-callbackQueueKeyLbl"
                onChange={(e) => changeSelectedQueue(e.target.value)}
            >
                <option value="" disabled hidden>
                    Välj ärende
                </option>
                {queues.map((queue, index) => (
                    <option key={index + 1} value={queue.queueKey} disabled={!queuesOpen[index]}>
                        {queue.displayName}
                    </option>
                ))}
            </select>
        </>
    );
};

export default WcbQueueKeySelect;
